import { memo } from 'react';

import { Tooltip, useTheme } from '@mui/material';
import { Building2, Lock } from 'lucide-react';

import { tooltipProps } from '@modules/_shared/components/feed-v2/constants/styles';
import { useLocale } from '@shared/hooks/locale';

export type ActivityVisibility = 'organisation' | 'private' | 'shared';

type Props = {
  visibility: ActivityVisibility | null | undefined;
};

export const VisibilityChip = memo(({ visibility }: Props) => {
  const { t } = useLocale();
  const theme = useTheme();
  const palette = (theme.vars ?? theme).palette;

  if (visibility === 'private') {
    return (
      <Tooltip title={t('Private')} {...tooltipProps}>
        <Lock size={14} color={palette.grey[600]} style={{ flexShrink: 0 }} />
      </Tooltip>
    );
  }

  if (visibility === 'organisation') {
    return (
      <Tooltip title={t('Shared within your organisation')} {...tooltipProps}>
        <Building2
          size={14}
          color={palette.grey[600]}
          style={{ flexShrink: 0 }}
        />
      </Tooltip>
    );
  }

  // 'shared', null, undefined → no chip
  return null;
});
